import { useLocation, useNavigate, useParams } from "react-router-dom";
import { appendSearchToPath } from "src/customHooks/usePaginatedTableSearchParams";
import RecruiterRecordDetails from "../../components/RecruiterRecordDetails";
import { useGetRecruiterRecordQuery } from "../../recruiter.service";
import { RecruiterKind } from "../../types/recruiter.entity";

const KINDS: RecruiterKind[] = ["applications", "help-requests", "searches"];

const RecruiterRecordPage = () => {
  const { kind, id } = useParams<{ kind: string; id: string }>();
  const location = useLocation();
  const navigate = useNavigate();
  const backToInbox = appendSearchToPath("/recruiter", location.search);

  const validKind = KINDS.find((k) => k === kind);
  const { data: record, isLoading, isError, error } = useGetRecruiterRecordQuery(
    { kind: validKind ?? "applications", id: id ?? "" },
    { skip: !validKind || !id }
  );

  if (isLoading) return <div className="p-6">Loading…</div>;

  if (!validKind || isError || !record) {
    return (
      <div className="page_container">
        <div className="border border-red-200 bg-red-50 p-6 text-center">
          <h2 className="mb-2 text-xl font-semibold text-red-800">Record not found</h2>
          <p className="mb-5 text-sm text-red-700">
            {typeof error === "string" ? error : "The link may be wrong, or the record has expired."}
          </p>
          <button
            onClick={() => navigate(backToInbox)}
            className="bg-red-600 px-4 py-2 text-sm font-medium text-white hover:bg-red-700"
          >
            Back to the inbox
          </button>
        </div>
      </div>
    );
  }

  return <RecruiterRecordDetails record={record} onBack={() => navigate(backToInbox)} />;
};

export default RecruiterRecordPage;
